import React from 'react';
import { isClickable, stepperItems } from './steps';
import {
  StepButton,
  StepConnector,
  StepItem,
  StepLabel,
  StepNumber,
  StepperRow,
  StepperScroll,
} from './style';

const toneOf = (item, viewing) => {
  if (item.route === viewing) return 'viewing';
  if (item.state === 'DONE') return 'done';
  return 'open';
};

/**
 * The stepper (tplA 436–446). It renders the server's `exam.steps[].state`
 * and never decides access itself (90 #63): LOCKED rows are not clickable,
 * every other row asks the server through onGo(route).
 */
export default function ExamStepper({ exam, viewing, onGo }) {
  const items = stepperItems(exam);
  return (
    <StepperScroll aria-label="Exam steps">
      <StepperRow>
        {items.map((item, index) => {
          const tone = toneOf(item, viewing);
          const isViewing = item.route === viewing;
          const clickable = isClickable(item.state) && !isViewing;
          return (
            <StepItem key={item.route} data-state={item.state}>
              {index > 0 && <StepConnector aria-hidden="true" />}
              <StepButton
                type="button"
                title={item.label}
                disabled={!clickable}
                aria-current={isViewing ? 'step' : undefined}
                aria-disabled={!isClickable(item.state) || undefined}
                data-testid={`exam-step-${item.route}`}
                onClick={() => clickable && onGo?.(item.route)}
              >
                <StepNumber $tone={tone}>{item.n}</StepNumber>
                <StepLabel $tone={tone} $viewing={isViewing}>
                  {item.label}
                </StepLabel>
              </StepButton>
            </StepItem>
          );
        })}
      </StepperRow>
    </StepperScroll>
  );
}
